module.exports = {
	"fi": {
		"static-pages": {
			"notFound": {
				"pageTitle": "Sivua ei löytynyt",
				"title": "Ei löytynyt",
				"details": "Etsimääsi sovellusta ei löytynyt. Oletko varma, että kirjoitit osoitteen oikein?",
				"goBack": "Mene takaisin"
			},
			"activation": {
				"pageTitle": "Turvallinen alue",
				"title": "Tervetuloa turvalliselle alueelle",
				"activate": {
					"details": "Pieni hetki, valmistelemme aktivointilinkkiäsi...",
					"ready": "Linkkisi on valmis. Paina painiketta edetäksesi. Huomaa: linkkiä voi käyttää vain kerran!",
					"go": "Aktivoi tili"
				},
				"passwordReset": {
					"details": "Pieni hetki, valmistelemme salasanan nollauslinkkiäsi...",
					"ready": "Linkkisi on valmis. Paina painiketta edetäksesi. Huomaa: linkkiä voi käyttää vain kerran!",
					"go": "Nollaa salasana"
				},
				"error": {
					"details": "Jotain meni pieleen linkkisi kanssa. Kokeilethan uudestaan tai ole yhteydessä tukipalveluun. Muistathan mainita koodin."
				}
			},
			"privacy-policy": {
				"pageTitle": "Kauppiasportaalin tietosuojakäytäntö"
			},
			"terms-and-conditions": {
				"pageTitle": "Kauppiasportaalin sopimus"
			},
			"Support": {
				"pageTitle": "Tuki",
				"topic": {
					"orders": "Tilaukset",
					"settlements": "Tilitykset",
					"agreements": "Sopimukset",
					"technical_issues": "Tekniset ongelmat",
					"others": "Muut"
				},
				"TicketList": {
					"title": "Tukipyynnöt",
					"pageDescription": "Voit tarkastella tukipyyntöjesi tilaa täällä",
					"status": {
						"open": "Avaa",
						"pending": "Odottava",
						"resolved": "Ratkaistu",
						"closed": "Suljettu",
						"inProgress": "Käsitellään",
						"waitingForYourReply": "Odotetaan vastaustasi"
					},
					"TicketTable": {
						"id": "Pyynnön numero",
						"mid": "Kauppa/kauppiastunnus",
						"subject": "Aiherivi",
						"status": "Tila",
						"updatedAt": "Päivitetty viimeksi"
					}
				},
				"EmptyTicketList": {
					"title": "Sinulla ei ole avoimia pyyntöjä"
				},
				"ticketDetails": {
					"sidebar": {
						"user": {
							"title": "Käyttäjä"
						},
						"details": {
							"title": "Tiedot",
							"store": "Kauppa/kauppiastunnus",
							"createdAt": "Pyynnön päivä",
							"updatedAt": "Päivitetty viimeksi"
						},
						"actions": {
							"close": "Sulje pyyntö",
							"reopen": "Avaa pyyntö uudelleen"
						},
						"closeTicketDialog": {
							"confirm": "Vahvista",
							"title": "Sulje pyyntö",
							"description": "Olet aikeissa sulkea tämän pyynnön. Pystyt avaamaan sen uudelleen ainoastaan seuraavien 7 päivän kuluessa.",
							"error": "Hups! Jokin meni pieleen, yritä uudelleen."
						},
						"reopenTicketDialog": {
							"title": "Avaa pyyntö uudelleen",
							"description": "Kerro lisää siitä, miksi sinun tarvitsee avata tämä pyyntö uudelleen, ja otamme sinuun pian yhteyttä.",
							"messageLabel": "Viesti"
						}
					},
					"conversation": {
						"loadMore": "Lataa enemmän",
						"title": "Pyyntö",
						"attachments": {
							"label": "Liitteet"
						},
						"reply": {
							"title": "Lisää vastaus",
							"body": {
								"label": "Lisää vastaus",
								"error": null
							},
							"attachment": {
								"label": "Lisää liitteitä",
								"error": "Tiedostojen koko ei saa ylittää kokonaisuudessaan 15 Mt"
							},
							"add": "Lisää vastaus",
							"cancel": "Peruuta",
							"submit": {
								"label": "Lähetä",
								"error": "Vastauksen tallennuksessa tapahtui virhe, yritä myöhemmin uudelleen"
							}
						}
					}
				},
				"errorView": {
					"429": {
						"title": "Hups!",
						"message": "Jokin meni pieleen, yritä uudelleen muutaman minuutin kuluttua. Mikäli ongelma jatkuu, ota meihin yhteyttä.",
						"contact": "Kun olet yhteydessä tukeen, ilmoitathan seuraavan korrelaatiotunnuksen",
						"action": "Ota meihin yhteyttä"
					},
					"error": "Virhe",
					"default": {
						"title": "Hups, jotain meni pieleen",
						"message": "Jostakin meistä johtuvasta syystä pyyntöäsi ei pystytä käsittelemään. Voit yrittää uudelleen tai palata myöhemmin takaisin.",
						"contact": "Kun olet yhteydessä tukeen, ilmoitathan seuraavan korrelaatiotunnuksen",
						"action": "Päivitä"
					}
				}
			},
			"Marketing": {
				"pageTitle": "Grab and Go -markkinointi",
				"banner": {
					"title": "Tervetuloa Grab and Go -markkinointiin!",
					"subtitle": "Täältä löydät helppokäyttöiset materiaalit verkkosivuillesi, sähköpostikampanjoihin ja markkinointiin sosiaalisessa mediassa.",
					"button": "Lue lisää"
				},
				"productSection": {
					"title": "Mitä Klarna-tuotetta tarjoat ostajille?"
				},
				"MarketSelector": {
					"label": "Valitse markkinat",
					"markets": {
						"BE": "Belgia (ranska)",
						"BE-FR": "Belgia (hollanti)"
					}
				},
				"ChannelSelector": {
					"pageTitle": {
						"kco": "Klarna Checkout",
						"fourInstallments": "4 erässä",
						"pin30": "Maksa 30 päivän kuluessa"
					}
				},
				"sourceAndPreview": {
					"helpButton": "Tarvitsetko apua tämän käytössä?",
					"copyButton": "Kopioi leikepöydälle",
					"copyButtonSuccess": "Kopioitu!",
					"sourceButton": "Lähde",
					"previewButton": "Esikatselu"
				},
				"EmailTemplates": {
					"pageTitle": "Sähköpostipohjat",
					"title": "Sähköpostipohjat"
				},
				"EmailHeader": {
					"pageTitle": "Sähköpostimarkkinoinnin kuva",
					"title": "Sähköpostimarkkinoinnin kuva"
				},
				"Social": {
					"pageTitle": "Sosiaalinen media",
					"title": "Sosiaalinen media"
				},
				"buttonDownload": "Lataa kuva",
				"buttonCopy": "Kopioi teksti",
				"buttonCopySuccess": "Kopioitu!",
				"missingPreview": "Esikatselu puuttuu",
				"productLinkText": "Tartu materiaaleihin",
				"content": {
					"products": {
						"kco": {
							"title": "Klarna Checkout",
							"subtitle": "Täydellinen kassajärjestelmä, jossa on kaikki yhdessä paikassa."
						},
						"payNow": {
							"title": "Maksa nyt",
							"subtitle": "Tarjoa ostajille mahdollisuus maksaa ostoksensa välittömästi."
						},
						"threeInstallments": {
							"title": "3 erässä",
							"subtitle": "Tarjoa ostajille vapaus jakaa kulut korottomasti pidemmälle ajalle."
						},
						"fourInstallments": {
							"title": "4 erässä",
							"subtitle": "Tarjoa ostajille vapaus jakaa kulut korottomasti pidemmälle ajalle."
						},
						"pin14": {
							"title": "Maksa 14 päivän kuluessa",
							"subtitle": "Maksa 14 päivän kuluessa. Ei korkoa tai lisämaksuja."
						},
						"pin21": {
							"title": "Maksa 21 päivän kuluessa",
							"subtitle": "Maksa 21 päivän kuluessa. Ei korkoa tai lisämaksuja."
						},
						"pin30": {
							"title": "Maksa 30 päivän kuluessa",
							"subtitle": "Maksa 30 päivän kuluessa. Ei korkoa tai lisämaksuja."
						},
						"financing": {
							"title": "Rahoitus",
							"subtitle": "Tehosta myyntiäsi tarjoamalla asiakkaille jopa 36 kuukautta maksuaikaa."
						}
					},
					"campaigns": {
						"holidays-2020": {
							"title": "Joulu 2020",
							"channels": {
								"emailHeader": {
									"title": "Sähköpostimarkkinoinnin kuva",
									"subtitle": "Herätä tilaajiesi mielenkiinto tänä jouluna sähköpostikampanjasi korkealaatuisten kuvien avulla.",
									"linkText": "Tarkastele kuvia",
									"introduction": "On aika kertoa tilaajillesi kaikki, mitä heidän tulee tietää mahtavista joulunajan tarjouksistasi ja -alennuksistasi. Lataa kuva ja lisää se sähköpostikampanjaasi tai sähköpostipohjan otsikkoon tehdäksesi suurimman vaikutuksen."
								},
								"social": {
									"title": "Sosiaalinen media",
									"subtitle": "Houkuttele lisää ostajia kauppaasi tänä jouluna näillä helppokäyttöisillä kuvilla.",
									"linkText": "Tarkastele julkaisuja",
									"introduction": "On aika levittää sanaa mahtavista joulunajan tarjouksistasi ja -alennuksistasi! Lataa vain materiaalit ja julkaise ne sosiaalisen median profiileihisi tai ajastustyökaluihisi. Muistathan merkitä Instagramiin {link} tavoittaaksesi entistä enemmän ostajia ja keskusteluja."
								}
							},
							"imageAlt": {
								"holiday1": "Siniseen, pinkkiin ja hopeaan pukeutunut henkilö liu'uttaa polveaan moppia kohti; kädessä hopeinen kenkä ja toisessa puhelin.",
								"holiday2": "Henkilö viininpunaisessa satiinipyjamassa istuu leijuen jalat ristissä pöytätuulettimen yllä, silmien tasolla älypuhelin."
							}
						},
						"at-launch": {
							"title": "Lanseerauksen yhteydessä",
							"subtitle": "Oletko vasta aloittanut matkasi kanssamme? Käytä näitä materiaaleja kertoaksesi niin uusille kuin vanhoille ostajillesi, että toimit yhteistyössä Klarnan kanssa.",
							"channels": {
								"email": {
									"title": "Sähköpostipohjat",
									"subtitle": "Kerro tilaajillesi, että saatavilla on uusi tapa maksaa kassalla.",
									"linkText": "Tarkastele pohjia",
									"introduction": "On aika kertoa tilaajillesi, että olet aloittanut yhteistyön Klarnan kanssa! Kopioi ja liitä vain pohja tai sisältö sähköpostialustallesi, ja kaikki on valmista.",
									"codeBoxTitle": "Aloita sähköpostitse"
								},
								"social": {
									"title": "Sosiaalinen media",
									"subtitle": "Houkuttele lisää ostajia kauppaasi näillä smoootheilla ammattilaistason kuvilla.",
									"linkText": "Tarkastele julkaisuja",
									"introduction": "On aika kertoa maailmalle, että olet aloittanut yhteistyön Klarnan kanssa! Lataa vain materiaalit ja julkaise ne sosiaalisen median profiileihisi tai ajastustyökaluihisi. Muistathan merkitä julkaisuihisi {link} tavoittaaksesi entistä enemmän ostajia ja keskusteluja."
								},
								"osm": {
									"title": "Laskeutumissivut",
									"subtitle": "Kerro asiakkaillesi, miten Klarnalla tehdään ostoksia.",
									"linkText": "Tarkastele sivuja"
								}
							},
							"imageAlt": {
								"emotional": "Haalariin pukeutunut henkilö, jolla on pitkät kiharat hiukset, pelaamassa metallista flipperiä",
								"paymentShowcase": "Käsi pitelemässä puhelinta, jossa näkyy Klarnan logo, taustalla rullaluistimet",
								"simplified": "Puhelin näyttö alaspäin, metallinen flipperi oikealla, kirkkaankeltainen sohva vasemmalla",
								"device": "Puhelin, jolla näkyy Klarnan logo, roikkumassa, taustalla vaaleanpunainen huone ja kattokruunu"
							}
						}
					}
				}
			}
		}
	}
};